import script from "./FormGeneralInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormGeneralInfo.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__